<template>
  <div>
    <SmsAuthCodes v-model="inputValues" />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import SmsAuthCodes from "@/components/molecules/form/SmsAuthCodes.vue";

@Component({
  components: {
    SmsAuthCodes
  }
})
export default class SmsAuthForm extends Vue {
  @Prop({
    type: String,
    default: null
  })
  value!: string | null;

  get inputValues() {
    return this.value;
  }
  set inputValues(newVal) {
    if (this.value !== newVal) this.$emit("input", newVal);
  }
}
</script>
